import { createSlice } from '@reduxjs/toolkit';
import { getCurrentUser, getUserSettings } from './thunk';

export interface UserInfo {
  id?: string;
  store?: string;
  roles?: string[];
}

export interface IUserData {
  currentUser: UserInfo | null;
  currentUserLoading: boolean;
  settings?: Record<string, any>;
}

const initialState: IUserData = {
  currentUser: null,
  currentUserLoading: true,
  settings: {},
};


const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    clearUser: (state) => {
      state.currentUser = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCurrentUser.fulfilled, (state, action) => {
        const user = action.payload;
        if (user && user.id && user.roles && (user.roles.includes('manager') || user.roles.includes('settings-admin'))) {
          state.currentUser = action.payload;
        }
        state.currentUserLoading = false;
      })
      .addCase(getCurrentUser.pending, (state) => {
        state.currentUserLoading = true;
      })
      .addCase(getCurrentUser.rejected, (state) => {
        state.currentUserLoading = false;
      });
    builder
      .addCase(getUserSettings.fulfilled, (state, action) => {
        state.settings = action.payload;
      });
  },
});

export const { clearUser } = slice.actions;
export default slice.reducer;
